module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": _vm.$vuetify.breakpoint.smAndDown ? '90%' : '50%',
      "scrollable": "",
      "persistent": "",
      "content-class": "elevation-0"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "hide-scrollbar pa-0 ma-0",
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'transparent' : 'rounded-xl'
  }, [_c('v-card-text', {
    staticClass: "ma-0 mt-n1",
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'px-8' : 'pa-0',
    staticStyle: {
      "z-index": "100"
    }
  }, [_c('v-card-title', {
    staticClass: "hidden-sm-and-up"
  }, [_c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "icon": "",
      "href": 'tel:' + _vm.bbr.handy,
      "disabled": !_vm.bbr.handy
    }
  }, [_c('v-icon', [_vm._v("phone")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-3",
          attrs: {
            "icon": "",
            "target": "_blank",
            "href": 'https://wa.me/' + _vm.bbr.handy.replace(/\s+/g, ''),
            "disabled": !_vm.bbr.handy
          }
        }, on), [_c('v-icon', [_vm._v("mdi-whatsapp")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": "",
      "width": "200px"
    }
  }, [_vm._v(" Whatsapp ")])], 1)]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": 'mailto:' + _vm.bbr.email,
      "disabled": !_vm.bbr.email
    }
  }, [_c('v-icon', [_vm._v("mail")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "mt-4 mb-n16 pb-n8 text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-avatar', {
    staticClass: "white",
    class: _vm.$vuetify.breakpoint.mdAndUp ? 'elevation-12' : '',
    attrs: {
      "size": "172"
    }
  }, [_c('v-avatar', {
    staticClass: "white elevation-0",
    staticStyle: {
      "z-index": "1000"
    },
    attrs: {
      "size": "156"
    },
    on: {
      "click": function($event) {
        _vm.showImage = true
      }
    }
  }, [(_vm.bbr.bildAhnengalerie500) ? _c('v-img', {
    staticClass: "ma-4 profilbild",
    attrs: {
      "max-height": "156",
      "src": _vm.bbr.bildAhnengalerie500
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-progress-circular', {
          attrs: {
            "size": "148",
            "width": "7",
            "indeterminate": "",
            "color": "primary"
          }
        })]
      },
      proxy: true
    }], null, false, 2530510412)
  }) : _c('v-icon', {
    staticClass: "grey lighten-3",
    attrs: {
      "light": "",
      "x-large": ""
    }
  }, [_vm._v("person")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "rounded-xl mt-n8 pt-8 pt-md-0",
    attrs: {
      "rounded": "",
      "flat": !_vm.$vuetify.breakpoint.mdAndUp
    }
  }, [_c('v-card-title', {
    staticClass: "hidden-sm-and-down"
  }, [(_vm.allowEdit) ? _c('v-btn', {
    staticClass: "green mr-2",
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.showBbrEdit = true
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-2",
          attrs: {
            "icon": "",
            "href": 'https://wa.me/' + _vm.bbr.handy.replace(/\s+/g, ''),
            "disabled": !_vm.bbr.handy
          }
        }, on), [_c('v-icon', [_vm._v("mdi-whatsapp")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_vm._v(" Whatsapp ")])], 1)]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "href": 'mailto:' + _vm.bbr.email,
            "target": "_blank",
            "disabled": !_vm.bbr.email
          }
        }, on), [_c('v-icon', [_vm._v("mail")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_c('v-card', {
    staticClass: "transparent",
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_vm._v(" Mail schreiben ")])], 1)]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "text-center pt-16 pt-md-8 d-flex justify-center"
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm._v(_vm._s(_vm.bbr.titel) + " " + _vm._s(_vm.bbr.vorname) + " " + _vm._s(_vm.bbr.nachname))]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, _vm._l((_vm.bbr.chargen), function(charge) {
    return _c('v-chip', {
      key: charge.semester,
      staticClass: "mr-1",
      staticStyle: {
        "height": "48px"
      },
      attrs: {
        "small": "",
        "label": "",
        "pill": ""
      }
    }, [_vm._v("\n                  " + _vm._s(charge.charge) + "\n                  "), _vm._v(" "), _c('br'), _vm._v("\n                  " + _vm._s(charge.semester) + "\n                ")])
  }), 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, _vm._l((_vm.felder.slice(
    0,
    Math.ceil(this.felder.filter(function (item) { return item.show; }).length / 2)
  )), function(feld, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "text-left"
    }, [(_vm.showHelp) ? _c('v-list-item-subtitle', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(feld.label))]) : _vm._e(), _vm._v(" "), (_vm.bbr[feld.value]) ? _c('span', [(feld.type === 'Date' && feld.value === 'geburtsdatum') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.bbr[feld.value], "DD.MM.YYYY")) + " (" + _vm._s(_vm.calculateAge(_vm.bbr[feld.value])) + "\n                        Jahre)")]) : (feld.type === 'Date') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.bbr[feld.value], "DD.MM.YYYY")))]) : _c('span', [_vm._v(" " + _vm._s(_vm.bbr[feld.value]))])]) : _vm._e()], 1)], 1)
  }), 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-1 px-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, _vm._l((_vm.felder.slice(Math.ceil(this.felder.filter(function (item) { return item.show; }).length / 2))), function(feld, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item-content', {
      staticClass: "text-left"
    }, [(_vm.showHelp) ? _c('v-list-item-subtitle', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(feld.label))]) : _vm._e(), _vm._v(" "), (_vm.bbr[feld.value]) ? _c('span', [(feld.type === 'Date' && feld.value === 'geburtsdatum') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.bbr[feld.value], "DD.MM.YYYY")))]) : (feld.type === 'Date') ? _c('span', [_vm._v(_vm._s(_vm.$filters.date(_vm.bbr[feld.value], "DD.MM.YYYY")))]) : (feld.type === 'Leibvater') ? _c('span', [_vm._v(_vm._s(_vm.$filters.user(_vm.bbr[feld.value], _vm.bundesbruder)))]) : (feld.type === 'Verbindungen') ? _c('span', _vm._l((_vm.bbr[feld.value]), function(i, num) {
      return _c('span', {
        key: num
      }, [_vm._v("\n                          " + _vm._s(i) + "\n                        ")])
    }), 0) : _c('span', [_vm._v(_vm._s(_vm.bbr[feld.value]))])]) : _vm._e()], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "30%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showImage),
      callback: function($$v) {
        _vm.showImage = $$v
      },
      expression: "showImage"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2 ma-0"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.bbr.bildAhnengalerie500,
      "width": "100%"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showImage = false
      }
    }
  }, [_vm._v("Schließen")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), (_vm.showBbrEdit) ? _c('dialogKontaktEdit', {
    attrs: {
      "visibleEdit": _vm.showBbrEdit,
      "bbr": _vm.bbr
    },
    on: {
      "update:visibleEdit": function($event) {
        _vm.showBbrEdit = $event
      },
      "update:visible-edit": function($event) {
        _vm.showBbrEdit = $event
      },
      "close": function($event) {
        _vm.showBbrEdit = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "100%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showStammbaum),
      callback: function($$v) {
        _vm.showStammbaum = $$v
      },
      expression: "showStammbaum"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-card-title', [_vm._v("\n        Leibfamilie - " + _vm._s(_vm.bbr.titel) + " " + _vm._s(_vm.bbr.vorname) + " " + _vm._s(_vm.bbr.nachname) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showStammbaum = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('stammbaum', {
    attrs: {
      "dense": _vm.denseStammbaum,
      "bbr": _vm.bbr,
      "currentBbr": _vm.bbr.id
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mb-6"
  }, [(_vm.denseStammbaum) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.denseStammbaum = !_vm.denseStammbaum
      }
    }
  }, [_c('v-icon', [_vm._v("zoom_out_map")])], 1) : _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.denseStammbaum = !_vm.denseStammbaum
      }
    }
  }, [_c('v-icon', [_vm._v("zoom_in_map")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showStammbaum = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26d828ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogKontakt.vue
// module id = 744
// module chunks = 15